export const PROCESSOR_SHOPIFY = 'shopify';
